<template>
  <AsPopup
    title="KQBD"
    wrapClass="as-popup__result-wrap"
    :popupClass="`as-popup__result as-popup__result-${siteName}`"
    :isShowPopup="isShowPopup"
    :isShowHeader="false"
    @toggle="toggle"
  >
    <template #content>
      <div class="as-popup__result-content">
        <div class="as-popup__result-header">
          <!-- <span class="as-match-status">{{
            getStatusName(match.status_id)
          }}</span> -->
          <div class="as-popup__result-competition">
            <img
              :src="getImgUrlBySport('competition', match.competition_id)"
              :alt="competitionName"
              class="as-lazyload as-match-as-competition__logo img-fluid"
            />
            <span class="as-match-as-competition__name">{{competitionName}}</span>
          </div>
          <button
            type="button"
            class="as-popup__result-close-btn"
            aria-label="Close"
            @click="$emit('toggle', false)"
          ></button>
        </div>
        <div class="as-popup__result-body">
          <div
            class="as-popup__result-team-info as-popup__result-team-info-new"
          >
            <div class="as-time as-flex as-text-center">
              {{ formatLocalTime(match.match_time, "h:mm DD/MM") }}
            </div>
            <div class="as-info as-flex as-text-center">
              <div class="as-team-home">
                <img
                  :src="getImgUrlBySport('team', match.home_team?.id)"
                  :alt="getTeamNameShow(match.home_team)"
                  class="as-lazyload as-popup__result-team-logo"
                />
                <span class="as-team-name">{{
                  getTeamNameShow(match.home_team)
                }}</span>
              </div>
              <div class="as-score">
                <div class="as-popup__result-score">
                  <ScoreVs :match="match" modifyClass="is-popup" />
                </div>
              </div>
              <div class="as-team-away">
                <img
                  :src="getImgUrlBySport('team', match.away_team?.id)"
                  :alt="getTeamNameShow(match.away_team)"
                  class="as-lazyload as-popup__result-team-logo"
                />
                <span class="as-team-name">{{
                  getTeamNameShow(match.away_team)
                }}</span>
              </div>
            </div>
            <div class="as-result as-flex as-text-center">
              <div class="as-popup__result-half-time-score">
                <div class="as-as-popup-item as-as-popup-item__result-half">
                  Kết quả hiệp 1:
                  <span class="as-score-value"
                    >{{ match.home_scores[1] }} -
                    {{ match.away_scores[1] }}</span
                  >
                </div>
                <div
                  v-if="match.leg && match.leg === 'Second Leg' && match.agg_score && match.agg_score.length"
                  class="as-as-popup-item as-as-popup-item__first-leg"
                >
                  Lượt đi:
                  <span class="as-score-value">
                    {{ firstLegScore.home }} - {{ firstLegScore.away }}
                  </span>
                </div>
                <div
                  v-if="match.leg && match.leg === 'Second Leg' && match.agg_score && match.agg_score.length"
                  class="as-as-popup-item as-as-popup-item__total-scores"
                >
                  Tổng tỉ số:
                  <span class="as-score-value">
                    {{ isAggScoreTotal ? match.agg_score[0] : parseInt(match.agg_score[0]) + match.home_scores[0] }} -
                    {{ isAggScoreTotal ? match.agg_score[1] : parseInt(match.agg_score[1]) + match.away_scores[0] }}</span>
                </div>
              </div>
              <StatsBtn :match="match" />
            </div>
          </div>

          <TabsIcon
            :tabs="tabs"
            :activeTab="activeTab"
            :isShowName="true"
            :isShowBorderTop="true"
            @change="changeTab"
          />
          <div class="as-popup__result-tab-content">
            <div v-if="activeTab === 'overview'">
              <Transition name="as-fade" mode="out-in">
                <IncidentsList
                  v-if="fetchedStatus.overview"
                  :match="match"
                  :incidents="incidents"
                />
                <IncidentsListSkeleton v-else />
              </Transition>
            </div>
            <div v-else-if="activeTab === 'statistics'">
              <Transition name="as-fade" mode="out-in">
                <StatisticsList
                  v-if="fetchedStatus.statistics"
                  :match="match"
                  :statistics="statistics"
                />
                <StatisticsListSkeleton v-else />
              </Transition>
            </div>
            <div v-else-if="activeTab === 'h2h'">
              <Transition name="as-fade" mode="out-in">
                <H2hList v-if="fetchedStatus.h2h" 
                  :match="match" 
                  :h2h="h2h" />
                <H2hListSkeleton v-else />
              </Transition>
            </div>
            <div v-else-if="activeTab === 'standing'">
              <Transition name="as-fade" mode="out-in">
                <StandingList
                  v-if="fetchedStatus.standing && !isStandingTab"
                  :match="match"
                  :standing="standing"
                />
                <StandingListTab
                  v-else-if="fetchedStatus.standing && isStandingTab"
                  :match="match"
                  :standing="standing"
                  :isShowFull="!isMobile"
                  :hideShowFull="!isMobile"
                />
                <StandingListSkeleton v-else />
              </Transition>
            </div>
            <div v-else-if="activeTab === 'lineups'">
              <Transition name="as-fade" mode="out-in">
                <Lineups
                  v-if="fetchedStatus.lineups"
                  :match="match"
                  :lineups="lineups"
                />
                <LineupTabSkeleton v-else />
              </Transition>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AsPopup>
</template>

<script setup lang="ts">
import { reactive, ref, watch, watchEffect, onMounted, computed } from "vue";
import IncidentsList from "~src/components/incidents/IncidentsList.vue";
import StatisticsList from "~src/components/statistics/StatisticsList.vue";;
import H2hList from "~src/components/h2h/H2hList.vue";
import StandingList from "~src/components/standings/StandingList.vue";
import StandingListTab from "~src/components/standings/StandingListTab.vue";
import Lineups from "~src/components/lineups/Lineups.vue";
import ScoreVs from "~src/components/matches/ScoreVs.vue";
import StatsBtn from "~src/components/matches/StatsBtn.vue";
import IconStats from "~src/components/icons/menus/IconStats.vue";
import IconSummary from "~src/components/icons/menus/IconSummary.vue";
import IconLineUp from "~src/components/icons/menus/IconLineUp.vue";
import IconStanding from "~src/components/icons/menus/IconStanding.vue";
import IconH2h from "~src/components/icons/menus/IconH2h.vue";
import TabsIcon from "~src/components/TabsIcon.vue";
import IncidentsListSkeleton from "~src/components/skeleton/result-popup/IncidentsListSkeleton.vue";
import StatisticsListSkeleton from "~src/components/skeleton/result-popup/StatisticsListSkeleton.vue";
import H2hListSkeleton from "~src/components/skeleton/result-popup/H2hListSkeleton.vue";
import LineupTabSkeleton from "~src/components/skeleton/result-popup/LineupTabSkeleton.vue";
import StandingListSkeleton from "~src/components/skeleton/standing/StandingListSkeleton.vue";

import {
  matchIncidents,
  matchStatistics,
  matchH2h,
  matchStanding,
  matchLineups,
} from "~src/services/SpapiService";
import MatchEnum from "~src/enums/MatchEnum";
import type { IMatch, ICompetitions } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  getTeamNameShow,
  getCompetitionNameShow
} from "~src/helpers";
import AsPopup from "~src/components/AsPopup.vue";
import { useIsMobile } from "~src/utils/isMobile";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

const emits = defineEmits(["toggle"]);

interface IProps {
  visible: boolean;
  match: IMatch;
  competition: ICompetitions;
  incidents: Array<Object>;
  isShowPopup: boolean;
  isStandingTab?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  incidents: () => [],
  isStandingTab: false,
});

const isMobile = ref(useIsMobile());
const siteName = computed(() => commonStore.getSiteName);

const competitionName = computed(() => getCompetitionNameShow(props.competition || props.match.competition));

// check trường hợp trận chưa kết thúc lượt đi chưa cộng vs lượt về
const isAggScoreTotal = computed(() => {
  return parseInt(props.match.agg_score[0]) - props.match.home_scores[0] >= 0
    && parseInt(props.match.agg_score[1]) - props.match.away_scores[0] >= 0
});

const isOvertimeScore  = computed(() => {
  return props.match.home_scores[5] > 0 || props.match.away_scores[5] > 0;
});

const firstLegScore  = computed(() => {
  let home = 0;
  let away = 0;
  if(isAggScoreTotal.value) {
    if(isOvertimeScore.value) {
      home =  props.match.agg_score[0] - props.match.home_scores[5];
      away =  props.match.agg_score[1] - props.match.away_scores[5];
    } else {
      home =  props.match.agg_score[0] - props.match.home_scores[0];
      away =  props.match.agg_score[1] - props.match.away_scores[0];
    }
  } else {
    home =  props.match.agg_score[0];
    away =  props.match.agg_score[1];
  }

  return {
    home,
    away
  }
});

const tabs = [
  {
    key: "overview",
    title: "Tổng Quan",
    icon: IconSummary,
  },
  {
    key: "statistics",
    title: "Thống Kê",
    icon: IconStats,
  },
  {
    key: "h2h",
    title: "Đối đầu",
    icon: IconH2h,
  },
  {
    key: "lineups",
    title: "Đội hình",
    icon: IconLineUp,
  },
  {
    key: "standing",
    title: "Bảng xếp hạng",
    icon: IconStanding,
  },
];

const activeTab = ref("overview");
const incidents = ref([]);
const statistics = ref([]);
const h2h = ref(null);
const standing = ref(null);
const lineups = ref(null);

const fetchedStatus = reactive<Record<string, boolean>>({});

const toggle = () => {
  emits("toggle");
};

watchEffect(() => {
  document.body.style.overflow = props.isShowPopup ? "hidden" : "auto";
});

onMounted(() => {
  changeTab("overview");
});

const changeTab = (tabName: string) => {
  activeTab.value = tabName;
  const matchId = props.match.id;
  const seasonId = props.match.season_id;
  if (!fetchedStatus[tabName]) {
    if (tabName === "statistics") {
      matchStatistics(matchId).then((response) => {
        statistics.value = response.data.data;
      }).finally(() => {
        fetchedStatus[tabName] = true;
      });
    } else if (tabName === "overview") {
      matchIncidents(matchId).then((response) => {
        incidents.value = response.data.data;
      }).finally(() => {
        fetchedStatus[tabName] = true;
      });
    } else if (tabName === "h2h") {
      if (!h2h.value) {
        matchH2h(matchId).then((response) => {
          h2h.value = response.data.data;
        }).finally(() => {
          fetchedStatus[tabName] = true;
        });
      }
    } else if (tabName === "standing") {
      if (!standing.value) {
        matchStanding(seasonId).then((response) => {
          standing.value = response.data.data;
        }).finally(() => {
          fetchedStatus[tabName] = true;
        });
      }
    } else if (tabName === "lineups") {
      if (!lineups.value) {
        matchLineups(matchId).then((response) => {
          lineups.value = response.data.data;
        }).finally(() => {
          fetchedStatus[tabName] = true;
        });
      }
    }
  }
};

const getStatusName = (str: keyof typeof MatchEnum.MATCH_STATUS_TEXT) => {
  return MatchEnum.MATCH_STATUS_TEXT[str];
};

const homeScores = props.match.home_scores || [];
const awayScores = props.match.away_scores || [];

const homeScore = computed(() => {
  let score = props.match.home_scores[0];

  // Trường hợp đá hiệp phụ
  if (homeScores[5] > 0) {
    score = homeScores[5];

    return score;
  }

  return score;
});

const awayScore = computed(() => {
  let score = awayScores[0];

  // Trường hợp đá hiệp phụ
  if (awayScores[5] > 0) {
    score = awayScores[5];

    return score;
  }

  return score;
});
</script>

<script lang="ts">
export default {};
</script>
